module.exports = __webpack_public_path__ + "static/media/login_full_bg4.4631d6ef.jpg";